import { useEffect } from "react";

// Proposals are written from the actions drawer, while what shows them sits
// elsewhere in the tree: « Mes propositions » and each « Envoyer la proposition ».
const listeners = new Set<() => void>();

export function notifyProposalsChanged() {
  for (const listener of listeners) listener();
}

/** Calls `listener` (a stable callback) when a proposal is added or sent. */
export function useOnProposalsChanged(listener: () => void) {
  useEffect(() => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, [listener]);
}
